import React, { useEffect, useRef, useState } from 'react';
import { Input } from '@vds/inputs';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { checkShadowGen } from '../config';
import MenuWrapper from './autcomplev1/menus';
import { getCurrentDocument } from '../utils/helperUtil';

// const MenuWrapper = React.lazy(() => import('./autcomplev1/menus'));

const StyledAutoCompleteWrapper = styled.div`
  position: relative;
  width: ${(props) => props.$width};
  div[class^='ComponentContainer-VDS'] {
    width: 100%;
  }
  @media screen and (max-width: 1023px) {
    width: 100%;
  }
`;

const menuObj = {
  light: {
    menu: {
      textColor: 'black',
      selectedColor: '#6092ed',
      textSelectedColor: 'black',
      backgroundColor: '#f3f3f5',
    },
  },
  dark: {
    menu: {
      textColor: 'white',
      selectedColor: 'white',
      textSelectedColor: 'black',
      backgroundColor: 'black',
    },
  },
};

const AutoComplteV1 = (props) => {
  const [showModal, setShowModal] = useState(false);
  const [dimensions, setDimensions] = useState(null);
  const selectedIndexVal = useRef(-1);
  const inputRef = props?.inputRef || useRef();
  const liveCountRef = useRef(null);
  const loopQualApp = useSelector((state) => state.loopQualApp);

  // const variant = getAutoCompleteVariant();
  const styleData = menuObj.light;
  const dropdownRef = useRef();
  const childrefs = [];
  const currentDocument = checkShadowGen() ? getCurrentDocument() : document.body;
  const currentActiveElement = checkShadowGen() ? getCurrentDocument() : document;

  useEffect(() => {
    if (props?.items) {
      setTimeout(() => {
        updateScroll();
      }, 500);
    }
  }, [props?.items]);

  useEffect(() => {
    if (liveCountRef.current) {
      if (showModal) {
        liveCountRef.current.textContent = `${props.items.length} suggested results`;
      } else {
        liveCountRef.current.textContent = undefined;
      }
    }
  }, [props?.items, showModal, liveCountRef]);
  useEffect(() => {
    const ro = new ResizeObserver(() => {
      if (inputRef.current?.parentElement?.parentElement) {
        getDimensions(inputRef.current.parentElement.parentElement);
      }
    });
    if (inputRef.current) {
      if (inputRef.current?.parentElement?.parentElement) {
        getDimensions(inputRef.current.parentElement.parentElement);
      }
      ro.disconnect();
      if (inputRef.current?.parentElement?.parentElement) {
        ro.observe(inputRef.current.parentElement.parentElement);
      }
    }
    return () => {
      ro.disconnect();
    };
  }, [inputRef.current]);
  useEffect(() => {
    document.addEventListener('scroll', updateScroll, true);
    return () => {
      document.removeEventListener('scroll', updateScroll, true);
    };
  }, []);
  useEffect(() => {
    if (props?.success) {
      setShowModal(false);
    } else {
      clearSelection(false, true);
    }
  }, [props?.success]);
  const triggetAccessbility = (target, indexSelected) => {
    if (target.current) {
      target.current.classList.add('selected');
      target.current.setAttribute('aria-selected', true);
      target.current.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      inputRef.current.setAttribute('aria-activedescendant', `dropdown-${props?.inputProps?.itemval}-item-${indexSelected}`);
    }
  };
  const inputProperties = {
    onFocus: (e) => {
      setShowModal(true);
      clearSelection(props?.value);
      if (props.onFocus) {
        props.onFocus(e);
      }
    },
    onClick: () => {
      console.log('onClick');
      if (inputRef.current?.parentElement?.parentElement) {
        getDimensions(inputRef.current.parentElement.parentElement);
      }
      setShowModal(true);
    },
    onKeyDown: (e) => {
      console.log('onKeyDown', e);
      // setSelectedIndex(-1);
      selectedIndexVal.current = -1;
      const selectedIndex = childrefs.findIndex((item) => item.current.classList.contains('selected'));
      const isKeyDown = e.keyCode === 40;
      const isKeyUp = e.keyCode === 38;
      const isEnter = e.keyCode === 13;
      if (isKeyDown || isKeyUp) {
        if (isKeyDown && !showModal) {
          setShowModal(true);
          return;
        }
        const defaultIndex = isKeyDown ? selectedIndex + 1 : selectedIndex - 1;
        const targetIndex = isKeyDown
          ? defaultIndex > childrefs.length - 1
            ? 0
            : defaultIndex
          : defaultIndex < 0
          ? childrefs.length - 1
          : defaultIndex;
        if (targetIndex > -1 && targetIndex < childrefs.length) {
          clearSelection();
          const selectedElem = childrefs[targetIndex];
          triggetAccessbility(selectedElem, targetIndex);
        }
      }
      if (isEnter) {
        if (!showModal) {
          setShowModal(true);
          return;
        }
        if (selectedIndex !== -1) {
          props?.onSelect(props?.items[selectedIndex][inputProperties?.itemval], props?.items[selectedIndex]);
          if (props?.items[selectedIndex][inputProperties?.itemval]?.toLowerCase()?.startsWith('show')) {
            selectedIndexVal.current = selectedIndex;
          } else {
            setShowModal(false);
          }
        }
      }
    },
    onBlur: (e) => {
      setTimeout(() => {
        console.log('childrefs', dropdownRef.current, e.relatedTarget);
        if (!dropdownRef.current?.contains(e.relatedTarget)) {
          props?.onBlur?.(e);
          setShowModal(false);
        }
      }, 0);
    },
    onChange: (e) => {
      props.onChange(e);
      if (!showModal) {
        setShowModal(true);
      }
      clearSelection(props?.value);
    },
    value: props?.value,
    ref: inputRef,
    error: props?.error,
    errorText: props?.errorText || '',
    'aria-expanded': showModal,
    'aria-controls': `dropdown-list-${props?.inputProps?.itemval}`,
    ...props?.inputProps,
  };

  const clearSelection = (selection = false, selectedItem = false) => {
    childrefs.forEach((item) => {
      item.current.classList.remove('selected');
      item.current.setAttribute('aria-selected', false);
      if (selectedItem) {
        if (childrefs?.[0]?.current) {
          item.current.classList.remove('selected_item');
          childrefs[0].current.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }
    });
    const getIndex = childrefs.findIndex((item) => item.current.textContent === selection);
    console.log('getIndex', getIndex, selection);
    if (getIndex > -1) {
      childrefs[getIndex].current.classList.add('selected_item');
      triggetAccessbility(childrefs[getIndex], getIndex);
    }

    if (selectedIndexVal.current > -1) {
      if (childrefs[selectedIndexVal.current]) {
        triggetAccessbility(childrefs[selectedIndexVal.current], selectedIndexVal.current);
      } else if (childrefs[props.items?.length - 1]) {
        triggetAccessbility(childrefs[props.items?.length - 1], props.items?.length - 1);
      }
    }
  };
  const getDimensions = (elem) => {
    setDimensions(elem.getBoundingClientRect());
  };

  const updateScroll = () => {
    if (inputRef?.current?.parentElement?.parentElement) {
      getDimensions(inputRef.current.parentElement.parentElement);
    }
  };

  const updateIndex = (index) => {
    selectedIndexVal.current = index;
  };

  // console.log('itemList', props?.items, showModal, props?.error);
  console.log('currentDocument', window?.vzlqw?.shadowRootEnabled, currentActiveElement.activeElement);
  return (
    <>
      <StyledAutoCompleteWrapper $width={props?.width}>
        {props.renderInput ? props.renderInput(inputProperties) : <Input {...inputProperties} />}
        <div ref={liveCountRef} role="status" aria-live="assertive" aria-relevant="additions" style={{ position: 'fixed', top: '-999999px' }} />
        {props.isPortal
          ? ReactDOM.createPortal(
              props?.items?.length > 0 && showModal && (
                <MenuWrapper
                  isPortal
                  setShowModal={setShowModal}
                  dropdownRef={dropdownRef}
                  childrefs={childrefs}
                  dimensions={dimensions}
                  clearSelection={clearSelection}
                  selectedValue={props?.value}
                  datatracker={props?.inputProps?.datatracker}
                  items={props.items}
                  updateIndex={updateIndex}
                  onSelectItem={props?.onSelect}
                  itemval={inputProperties?.itemval}
                  triggetAccessbility={triggetAccessbility}
                  loopQualApp={loopQualApp}
                  menuStyles={styleData?.menu || {}}
                />
              ),
              currentDocument,
            )
          : props?.items?.length > 0 &&
            showModal && (
              <MenuWrapper
                setShowModal={setShowModal}
                dropdownRef={dropdownRef}
                childrefs={childrefs}
                dimensions={dimensions}
                clearSelection={clearSelection}
                selectedValue={props?.value}
                datatracker={props?.inputProps?.datatracker}
                items={props.items}
                updateIndex={updateIndex}
                onSelectItem={props?.onSelect}
                itemval={inputProperties?.itemval}
                triggetAccessbility={triggetAccessbility}
                loopQualApp={loopQualApp}
                menuStyles={styleData?.menu || {}}
              />
            )}
      </StyledAutoCompleteWrapper>
    </>
  );
};

export default AutoComplteV1;

AutoComplteV1.defaultProps = {
  variant: 'AC_V1_T1',
  isPortal: false,
};
AutoComplteV1.propTypes = {
  renderInput: PropTypes.func,
  items: PropTypes.any,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  error: PropTypes.bool,
  errorText: PropTypes.string,
  onSelect: PropTypes.func,
  value: PropTypes.any,
  inputProps: PropTypes.object,
  inputRef: PropTypes.any,
  width: PropTypes.any,
  variant: PropTypes.oneOf(['dark', 'light']),
  success: PropTypes.bool,
  onFocus: PropTypes.func,
  isPortal: PropTypes.bool,
};
